// libs
import { useEffect } from "react";

export function useMount(callback) {
  useEffect(callback, []);
}

export function useNoScroll(onlyIf = true) {
  useEffect(() => {
    if (onlyIf) document.documentElement.classList.add("no-scroll");
    return () => {
      if (onlyIf) document.documentElement.classList.remove("no-scroll");
    };
  });
}

export function useResize(listener) {
  useEffect(() => {
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  });
}
